<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper">
      <div class="page__header">
        <div class="page__title">
          <Title>{{$t($route.meta.title)}}</Title>
        </div>
      </div>
      <div class="page__body">
        <template v-if="menuItems && menuItems.length > 0">
          <MenuList @select="onSelect" :items="menuItems"/>
        </template>
        <template v-else>
          <div class="page__caption">
            {{ $t('common.empty') }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/titles/Title'
import MenuList from '@/components/menu/MenuList'
import HomeController from './home-controller'

import {VIEWS} from '@/views/names'

export default {
  name: VIEWS.home.name,
  mixins: [HomeController],
  components: {
    Title,
    MenuList
  }
}
</script>
